import React from 'react'
// import {getColorIconBase} from './SubmissionMenu/icon-svg-getters/get-color-icon.js'
import {getIcon} from './SubmissionMenu/icon-svg-getters/icon-categories.js'


export default class SubmissionMenuOption extends React.Component { //TODO: Remove/edit this, but reuse the click handler

  handleClick(e) {
    e.preventDefault();
    this.props.handleClick(this.props.model)
  }

  handleHover(e) {
    this.props.handleHover(this.props.model)
  }

  getColors() {

    const model = this.props.model;
    if (model.isSelected && !this.props.isTouchMode) {

      if (model.isUnavailable) {
        //selected but not able to submit
        return {
          background: "linear-gradient( to top, #696969 0%,#696969 90%,#5E5E5E 90.0%,#5E5E5E 100%)", //disabled gray
          color: "#C8C8C8" //dark terminal bg color
        }
      }

      //selected for real!
      return {
        //background: "#69F8BF", //computer hacky green
        background: "linear-gradient( to top, #83FFCE 0%,#83FFCE 90%,#66EEB8 90.0%,#66EEB8 100%)", //computery green
        color: "#042129" //dark terminal bg color
      }
    }

    //NOTE: There is a weird problem with `isDisabled` where the cursor is blocked from arrowing through?
    //If ITEMS is disabled, you cannot access SUPER. It's super weird. Switching to isUnavailable which allows cursoring
    if (model.isDisabled || model.isUnavailable) {
      //disabled: gray and sad (not selected)
      return {
        color: "#666"
      }
    }
    //Default. Available but not selected
    return {
      color: "#FCFCFC" //whiteish
    }
  }

  // getDangerMeterProgress() {
  //   const style = {
  //     display: "inline-block",
  //     marginLeft: "1em"
  //   };
  //   return (
  //     <span style={style}>[{this.props.model.viewBag.dangerMeter}]</span>
  //   )
  // }

  getMetaStyle() {
    const model = this.props.model;
    if (model.isSelected && !this.props.isTouchMode && model.isUnavailable ) {
      return {
        color: "#FB6B6B" //red
      }
    }
    return {}
  }

  // getRevertBadge() {
  //   const style = {
  //     display: "inline-block",
  //     marginLeft: "2em",
  //     fontSize: "0.7em"
  //   };
  //   return (
  //     <span style={style}>Commit Available</span>
  //   )
  // }
  //
  // renderSuperChargeOption(style, iconStyle) {
  //
  //   return (
  //     <a href="#" className="ArenaSubmissionOption" style={style} onClick={this.handleClick.bind(this)}
  //        onMouseEnter={this.handleHover.bind(this)}>
  //       <span style={iconStyle}/>
  //       <span className="ArenaSubmissionOption-label">
  //         {this.props.model.viewBag.superName}
  //       </span>
  //       <span>{this.getDangerMeterProgress()}</span>
  //       <span>{ this.props.model.viewBag.hasRevertAvailable ? this.getRevertBadge() : null}</span>
  //     </a>
  //   );
  // }

  render() {
    const {model} = this.props;
    
    const optionTextContainerStyle = {
        padding: "1em 1em",
      ...this.getColors()
    };

    const iconContainerStyle = {
      display: "block",
      marginRight: "0.5em"
    };
    const iconCellStyle = {
      boxShadow: "0 0.25em 0 0 rgba(0,0,0,0.3)"
    };

    const iconSvg = getIcon(model.viewBag.actionCategory, "1.8em");


    return (
      <a className="ArenaSubmissionOption" href="#" onClick={this.handleClick.bind(this)}
         onMouseOver={this.handleHover.bind(this)}>
          <span style={iconContainerStyle}>
            <span style={iconCellStyle}>
              {iconSvg}
            </span>
          </span>
          <span className="ArenaSubmissionOption-label" style={optionTextContainerStyle}>
            <span>{model.label}</span>
            <span className="ArenaSubmissionOption-meta" style={this.getMetaStyle()}>{model.viewBag.metaData || null}</span>
          </span>
      </a>
    );
  }
}
/* eslint jsx-a11y/href-no-hash: "off" */


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenuOption.js